import { useState } from "react";
import { Box,TextareaAutosize, Typography,Modal } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import LocalPhoneIcon from "@mui/icons-material/LocalPhone";
import EmailIcon from "@mui/icons-material/Email";

const style = {
    position: "absolute" as "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    bgcolor: "background.paper",
    borderRadius: "10px",
    padding: "22px",
};

const ContactModal = (props:any) => {
    const[helpText, setHelpText] = useState("")
    
    const handleSubmit = (event:any) =>{
      event.preventDefault();
      setHelpText("");
      props.close()
    }
    return (
        <Modal open={props.open} onClose={props.close} aria-labelledby="modal-modal-title" aria-describedby="modal-modal-description">
        <Box className="Support" sx={style}>
          <Box sx={{ display: "flex", justifyContent: "space-between" }}>
            <Typography id="modal-modal-title" variant="h5" component="h2">
              Contact Us
            </Typography>
            <CloseIcon sx={{ cursor: "pointer" }} fontSize="medium" onClick={props.close} />
          </Box>
          <Box className="border_line" sx={{backgroundColor: "#EEEEEE",height: "1px",mt: "15px", mb: 3}}></Box>
          <Box id="modal-modal-description" className="Support_Center_modal" sx={{ mt: 2 }}>
            Do you have any issue, Reach us via email or phone.
            <Box className="phoneInfo" sx={{display: "flex",alignItems: "center",mt: 4,color: "#152536",pl: 2}}>
              <LocalPhoneIcon />
              <Typography>0800 211 8197 <span> - speak to one of or team.</span></Typography>
            </Box>
            <Box className="phoneInfo" sx={{display: "flex",alignItems: "center",mt: 4,color: "#152536",pl: 2}}>
              <EmailIcon />
              <Typography>
                Use the form below <span> - we aim to respond within 2 working hours.</span>
              </Typography>
            </Box>
            <form onSubmit={handleSubmit}>
              <Box className="How_Help">
                <Typography sx={{ mt: 5, color: "#152536" }}>How can we help?</Typography>
                <TextareaAutosize value={helpText} onChange={(event)=>{setHelpText(event.target.value)}} className="textarea" minRows={5} placeholder="Enter a message" />
              </Box>
              <Box textAlign="right">
                <button type="submit" className="btn-primary"> Send</button>
              </Box>
            </form>
          </Box>
        </Box>
      </Modal>
    )
}

export default ContactModal
